// Import model
import { StartRoomPhotoFileAskSyntheaRequest } from '../models/StartRoomPhotoFileAskSyntheaRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartRoomPhotoFileAskSyntheaRequest - handles JSON serialization and deserialization with type validation
 */
export class StartRoomPhotoFileAskSyntheaRequestSerializer {
  /**
   * Deserializes a JSON string into a StartRoomPhotoFileAskSyntheaRequest instance
   */
  static deserialize(json: string): StartRoomPhotoFileAskSyntheaRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartRoomPhotoFileAskSyntheaRequest instance
   */
  static fromObject(obj: any): StartRoomPhotoFileAskSyntheaRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartRoomPhotoFileAskSyntheaRequest');
    }


    const instance: StartRoomPhotoFileAskSyntheaRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartRoomPhotoFileAskSyntheaRequest instances
   */
  static deserializeArray(json: string): StartRoomPhotoFileAskSyntheaRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartRoomPhotoFileAskSyntheaRequest instance to a JSON string
   */
  static serialize(instance: StartRoomPhotoFileAskSyntheaRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartRoomPhotoFileAskSyntheaRequest instance to a plain object
   */
  static toObject(instance: StartRoomPhotoFileAskSyntheaRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartRoomPhotoFileAskSyntheaRequest instances to a JSON string
   */
  static serializeArray(instances: StartRoomPhotoFileAskSyntheaRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
